module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isRouterAlive) ? _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: (_vm.title),
      expression: "title"
    }]
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.keepAlive && _vm.isRouterAlive) ? _c('router-view', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: (_vm.title),
      expression: "title"
    }]
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03d40f46"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 775
// module chunks = 10